// eslint-disable-next-line import/prefer-default-export
export function isAuthenticated() {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user && user.token) {
    if (user.token) return true;
    return false;
  }
  return false;
}
